import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { ReactComponent as AlertIcon } from 'assets/icons/a11ymenu_alert.svg';
import { useTranslation } from 'react-i18next';

interface GenerationDiscardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
  fromParent: string;
}

enum ParentType {
  AltTextModal = 'AltTextModal',
  ImproveText = 'ImproveText',
}

export const GenerationDiscardModal = ({ isOpen, onClose, onDiscard, fromParent }: GenerationDiscardModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size='sm' portalProps={{ appendToParentPortal: false }} isCentered>
      <ModalOverlay />
      <GenerationDiscardModalContent onClose={onClose} onDiscard={onDiscard} fromParent={fromParent} />
    </Modal>
  );
};

interface GenerationDiscardModalContentProps {
  onDiscard: () => void;
  onClose: () => void;
  fromParent: string;
}

const GenerationDiscardModalContent = ({ onDiscard, onClose, fromParent }: GenerationDiscardModalContentProps) => {
  const { t } = useTranslation('editor_widget_toolbar', {
    useSuspense: false,
    keyPrefix: 'textToolbar.improveText.discardGeneration',
  });
  const handleDiscard = () => {
    onDiscard();
    onClose();
  };

  const header = t('modal.header');
  const bodyText = fromParent !== ParentType.AltTextModal ? t('modal.body') : t('modal.bodyAltText');
  const cancelText = t('modal.cancel');
  const discardText = t('modal.discard');

  return (
    <ModalContent>
      <ModalHeader w='calc(100% - 5%)'>
        <Flex alignItems='center' gap={2}>
          <AlertIcon color='var(--vg-colors-font-500)' />
          <Text>{header}</Text>
        </Flex>
      </ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <Text>{bodyText}</Text>
      </ModalBody>
      <ModalFooter>
        <Flex justifyContent='flex-end' gap={2}>
          <Button variant='ghost' onClick={onClose} size='sm'>
            {cancelText}
          </Button>
          <Button variant='outline' onClick={handleDiscard} size='sm'>
            {discardText}
          </Button>
        </Flex>
      </ModalFooter>
    </ModalContent>
  );
};
